export default function CustomerPortalSection() {
  return (
    <section id="portal" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-4">
              Mobil Müşteri Portalı
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
              Bitmeyen müşteri telefonlarına son verin!
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              “Benim hissem hangisi, borcum ne kadar, kesim sıram geldi mi?” sorularını tek tek yanıtlamak zorunda kalmayın. CiftlikWeb Müşteri Portalı ile hissedarlar kendi kurbanlarını, ödemelerini ve kesim durumlarını uygulama indirmeden cep telefonlarından canlı takip eder.
            </p>
            <a
              href="#demo"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Müşteri portalını demo&apos;da görün
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex-1 w-full max-w-md flex justify-center">
            <div className="phone-device bg-background-50 overflow-hidden shadow-xl">
              <div className="phone-device__speaker" aria-hidden="true"></div>
              <div className="bg-primary-500 px-4 pt-7 pb-3">
                <span className="text-background-50 text-sm font-semibold font-heading">Müşteri Portalım</span>
              </div>
              <div className="divide-y divide-background-100">
                <div className="p-4 flex items-center gap-3 hover:bg-background-50 transition-colors cursor-default">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-50 rounded-lg">
                    <i className="ri-shopping-bag-line text-primary-500"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800">Aktif Siparişlerim</p>
                    <p className="text-xs text-foreground-500">3 sipariş</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>

                <div className="p-4 flex items-center gap-3 hover:bg-background-50 transition-colors cursor-default">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-50 rounded-lg">
                    <i className="ri-bank-card-line text-accent-500"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800">Ödeme Geçmişim</p>
                    <p className="text-xs text-foreground-500">5 işlem</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>

                <div className="p-4 flex items-center gap-3 hover:bg-background-50 transition-colors cursor-default">
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-50 rounded-lg">
                    <i className="ri-wallet-3-line text-secondary-600"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800">Kalan Bakiye</p>
                    <p className="text-xs text-foreground-500">₺12.500</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>

                <div className="p-4 flex items-center gap-3 hover:bg-background-50 transition-colors cursor-default">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-50 rounded-lg">
                    <i className="ri-knife-line text-primary-500"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800">Kesim Durumu</p>
                    <p className="text-xs text-primary-600 font-medium">Planlandı - 12 Haz</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>

                <div className="p-4 flex items-center gap-3 hover:bg-background-50 transition-colors cursor-default">
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-50 rounded-lg">
                    <i className="ri-truck-line text-secondary-600"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800">Taşıma Durumu</p>
                    <p className="text-xs text-foreground-500">Teslim edilmedi</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
